import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  BtnIcon,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomPanel,
  CustomTabView,
  Loading,
  PageHeader,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  getHistoricoDeLeitura,
  putFinalizarAreaSeparacao,
} from '../../../../services/api/https/picking/picking.http'
import { TabPanel } from 'primereact/tabview'
import TabHistorico from './TabHistorico'
import TabBipsExcluidos from './TabBipsExcluidos'
import TabBipsFaltantes from './TabBipsFaltantes'
import TabTagsExcluidas from './TabTagsExcluidas'
import CardsHistoricoLeitura from './CardsHistoricoLeitura'
import TabSeparacaoPorProduto from './TabSeparacaoPorProduto'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import PickingAreaStatus from '../../../../components//PickingAreaStatus/PickingAreaStatus'
import { FaCheck } from 'react-icons/fa'
import { azul_escuro, gray } from '../../../../assets/js/colors'
import './HistoricoLeitura.css'
import { normalizeCardInfosTimezone } from './historicoLeitura.helpers'

const HistoricoLeitura = ({ history, dispatch }) => {
  // Vars
  const { pickingId } = history.location.state

  // Hooks
  const [bips, setBips] = React.useState([])
  const [deletedBips, setDeletedBips] = React.useState([])
  const [deletedPallets, setDeletedPallets] = React.useState([])
  const [cardInfos, setCardsInfo] = React.useState([])
  const [areas, setAreas] = React.useState([])
  const [produtos, setProdutos] = React.useState([])
  const [pickingStyle, setPickingStyle] = React.useState(null)
  const [finalizadoPorUser, setFinalizadoPorUser] = React.useState(null)
  const [isLoading, setIsLoading] = React.useState(true)
  const [globalFilter, setGlobalFilter] = React.useState('')
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(null)

  // React.useEffect(() => {
  //     _getBipHistory()
  // }, [])

  React.useEffect(() => {
    isLoading && _getBipHistory()
  }, [isLoading])

  // Helpers
  const _getBipHistory = async () => {
    try {
      if (!pickingId) throw new Error('Clique em Voltar e selecione o picking desejado')
      const {
        beeps,
        deleted_beeps,
        deleted_pallets,
        infos,
        areas,
        finalizado_por_user,
        produtos,
        picking_style,
      } = await getHistoricoDeLeitura(pickingId)
      setBips(beeps)
      setDeletedBips(deleted_beeps || [])
      setDeletedPallets(deleted_pallets || [])
      setFinalizadoPorUser(finalizado_por_user)
      setProdutos(produtos || [])
      setPickingStyle(picking_style || null)
      setCardsInfo(normalizeCardInfosTimezone(infos))
      setAreas(
        (areas || []).map(area => ({
          ...area,
          qte_total: Number(area.qte_total),
          qte_picked: Number(area.qte_picked),
          percentual_separacao: Number(area.qte_total)
            ? (Number(area.qte_picked) / Number(area.qte_total)) * 100
            : 0,
        })),
      )
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      setIsLoading(false)
    }
  }

  const finalizarAreaDeSeparacao = async (pickingId, areaId) => {
    try {
      dispatch(showLoadingBox('Aguarde', 'Finalizando area de separação'))
      await putFinalizarAreaSeparacao({ pickingId: pickingId, areaId: areaId })
        .then(() => {
          setAreas(prevAreas => {
            const index = prevAreas.findIndex(area => area.area_id === areaId)
            if (index !== -1) prevAreas[index].status = 'Finalizado'
            return [...prevAreas]
          })
        })
        .catch(err => {
          throw err
        })
    } catch (e) {
      dispatch(showMessageBox(null, errorHandler(e)))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  // Render
  return (
    <>
      <PageHeader>Histórico de Leitura/Bip</PageHeader>
      <div style={{ marginTop: 20 }} className="p-grid">
        <CustomPanel
          showBtnNovo={true}
          btnLabel={'Atualizar'}
          onNovo={() => setIsLoading(true)}
          onVoltar={history.goBack}
        >
          {isLoading ? (
            <div className="text-center">
              <Loading />
            </div>
          ) : (
            <CustomTabView activeIndex={0}>
              <TabPanel header={'Informações'}>
                <div className="p-grid p-col-12">
                  <CardsHistoricoLeitura
                    cardInfos={cardInfos}
                    finalizadoPorUser={finalizadoPorUser}
                  />
                  <div className="p-col-12">
                    <CustomTabView activeIndex={0}>
                      <TabPanel header={'% Separação Por Área'}>
                        <DataTable
                          header={<CustomDataTableHeader onChange={setGlobalFilter} />}
                          globalFilter={globalFilter}
                          responsive={true}
                          value={areas}
                          emptyMessage={'Nenhuma informação disponível'}
                        >
                          <Column
                            className="column-responsive"
                            field={'area_name'}
                            header={'Áreas'}
                            style={{ width: '100%', textAlign: 'start' }}
                          />
                          <Column
                            className="column-responsive"
                            field={'area_apelido'}
                            header={'Apelido'}
                            style={tableCellCentered(200)}
                          />
                          <Column
                            className="column-responsive"
                            field={'qte_total'}
                            header={'Qte. Total'}
                            style={tableCellCentered(70)}
                            sortable
                          />
                          <Column
                            className="hide-column column-responsive"
                            field={'qte_picked'}
                            header={'Qte Separada'}
                            style={tableCellCentered(90)}
                            sortable
                          />
                          <Column
                            className="column-responsive"
                            field={'percentual_separacao'}
                            header={'% Separação'}
                            style={tableCellCentered(90)}
                            sortable
                            body={item => {
                              return ((item.qte_picked / item.qte_total) * 100).toFixed(0) + '%'
                            }}
                          />
                          <Column
                            className="column-responsive"
                            header={'Status'}
                            style={{
                              ...tableCellCentered(),
                              display:
                                areas.length > 0 && areas.some(a => a.status)
                                  ? 'table-cell'
                                  : 'none',
                            }}
                            body={item => <PickingAreaStatus status={item.status} />}
                          />
                          <Column
                            className="column-responsive"
                            header={'Finalizar'}
                            style={{
                              ...tableCellCentered(80),
                              display:
                                areas.length > 0 &&
                                areas[0].tp_id === 65 &&
                                areas.some(a => a.status)
                                  ? 'table-cell'
                                  : 'none',
                            }}
                            body={item =>
                              item.status !== 'Finalizado' ? (
                                <BtnIcon onClick={() => setShowConfirmDialog(item)}>
                                  <FaCheck size={18} color={azul_escuro} />
                                </BtnIcon>
                              ) : (
                                <FaCheck size={18} color={gray} />
                              )
                            }
                          />
                        </DataTable>
                      </TabPanel>
                      <TabPanel header={'% Separação Por Produto'}>
                        <TabSeparacaoPorProduto produtos={produtos} pickingStyle={pickingStyle} />
                      </TabPanel>
                    </CustomTabView>
                  </div>
                </div>
              </TabPanel>
              <TabPanel header={'Histórico'}>
                {isLoading ? (
                  <div className="text-center">
                    <Loading />
                  </div>
                ) : (
                  <TabHistorico bips={bips} pickingId={pickingId} />
                )}
              </TabPanel>
              <TabPanel header={'BIPs Excluídos'}>
                {isLoading ? (
                  <div className="text-center">
                    <Loading />
                  </div>
                ) : (
                  <TabBipsExcluidos bips={deletedBips} pickingId={pickingId} />
                )}
              </TabPanel>
              <TabPanel header={'BIPs Faltantes'}>
                <TabBipsFaltantes pickingId={pickingId} />
              </TabPanel>
              <TabPanel header={'Tags Excluídas'}>
                {isLoading ? (
                  <div className="text-center">
                    <Loading />
                  </div>
                ) : (
                  <TabTagsExcluidas tags={deletedPallets} />
                )}
              </TabPanel>
            </CustomTabView>
          )}
        </CustomPanel>
        <ConfirmDialog
          title="Atenção"
          content="Essa operação não poderá ser desfeita. Confirma a finalização da area de separação ?"
          isVisible={showConfirmDialog ? true : false}
          onCancelar={() => setShowConfirmDialog(null)}
          onOk={() => {
            finalizarAreaDeSeparacao(pickingId, showConfirmDialog.area_id)
            setShowConfirmDialog(null)
          }}
        />
      </div>
    </>
  )
}

export default connect()(withRouter(HistoricoLeitura))
